<template>
  <v-card class="rounded-xl ma-2 pa-8">
    <v-data-table
      :headers="headersRadioGroups"
      :items="updatedAvailableRadioGroups"
      :items-per-page="-1"
      dense
      disable-pagination
      hide-default-footer
    >
      <template v-slot:top>
        <div class="d-flex flex-row flex-wrap">
          <v-card-title>
            Available Radio Groups
          </v-card-title>

          <v-spacer />

          <v-btn
            color="ppc_pink"
            dark
            x-small
            absolute
            right
            fab
            @click="$emit('open-radio-group')"
          >
            <v-icon>$vuetify.icons.icon_mdi_plus</v-icon>
          </v-btn>
        </div>

        <v-dialog
          :value="dialogRadioGroup"
          max-width="1000px"
          persistent
          @input="$emit('update-dialog-radio-group', $event)"
        >
          <v-form ref="radioGroupForm">
            <v-card>
              <v-card-title class="ppc_darkgreen darken-1">
                <span class="headline white--text">
                  {{ formTitleRadioGroups }}
                </span>
              </v-card-title>

              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    md="8"
                  >
                    <v-text-field
                      v-model.trim="editedRadioGroup.radio_group_name"
                      label="Name (required)"
                      counter="45"
                      :rules="inputRulesName"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model.trim="editedRadioGroup.radio_group_question"
                      label="Question (required)"
                      counter="100"
                      :rules="inputRules100maxReq"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model.trim="editedRadioGroup.info_link"
                      label="Info link"
                      counter="100"
                      :rules="inputRules100max"
                    />
                  </v-col>

                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  />
                </v-row>
              </v-card-text>

              <!-- Radio options -->
              <v-card flat>
                <v-card-text>
                  <v-data-table
                    v-model="selectedDefaultOption"
                    :headers="headersRadioOptions"
                    :items="editedRadioGroup.options"
                    hide-default-footer
                    single-select
                    show-select
                    item-key="label"
                    disable-sort
                    @item-selected="changeDefault"
                  >
                    <template v-slot:top>
                      <v-toolbar flat>
                        <v-toolbar-title>
                          Options
                        </v-toolbar-title>

                        <v-divider
                          class="mx-4"
                          inset
                          vertical
                        />

                        (minimal 2 options and select a default value)

                        <v-spacer />

                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  color="ppc_pink"
                                  v-bind="attrs"
                                  dark
                                  absolute
                                  right
                                  x-small
                                  fab
                                  class="mx-4 my-0 mt-2"
                                  v-on="on"
                                  @click="$emit('open-radio-option')"
                              >
                                  <v-icon v-on="on">
                                    $vuetify.icons.icon_mdi_plus
                                  </v-icon>
                              </v-btn>
                          </template>

                          <span>Add an option</span>
                      </v-tooltip>

                      </v-toolbar>
                    </template>

                    <template v-slot:[`item.actions`]="{ item }">
                      <v-icon
                        small
                        class="mr-2"
                        @click="$emit('open-radio-option', item)"
                      >
                        $vuetify.icons.icon_mdi_pencil
                      </v-icon>

                      <v-icon
                        small
                        @click="$emit('delete-radio-option', item)"
                      >
                        $vuetify.icons.icon_mdi_delete
                      </v-icon>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>

              <v-card-actions>
                <v-spacer />

                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="$emit('close-radio-group')"
                >
                  Cancel
                </v-btn>

                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="saveRadioGroup"
                >
                  Done
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <v-dialog
          :value="dialogDeleteRadioGroup"
          max-width="500px"
          @input="$emit('update-dialog-delete-radio-group', $event)"
        >
          <v-card>
            <v-card-title class="headline">
              Delete Radio Group?
            </v-card-title>

            <v-card-text>
              Are you sure you want to delete this radio group?
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn
                text
                @click="$emit('close-delete-radio-group')"
              >
                Cancel
              </v-btn>

              <v-btn
                color="error"
                text
                @click="$emit('delete-radio-group-confirm')"
              >
                Delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          :value="dialogRadioOption"
          max-width="500px"
          persistent
          @input="$emit('update-dialog-radio-option', $event)"
        >
          <v-form ref="formRadioOptions">
            <v-card>
              <v-card-title class="ppc_darkgreen darken-1">
                <span class="headline white--text">{{ formTitleRadioOptions }}</span>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                  >
                    <v-text-field
                      v-model.trim="editedRadioOptionItem.label"
                      label="Label"
                      counter="100"
                      :rules="inputRules100max"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedRadioOptionItem.price"
                      label="Price"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedRadioOptionItem.varPrice"
                      label="Variable price"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedRadioOptionItem.duration"
                      label="Duration"
                      clearable
                      :disabled="editedRadioOptionItem.min_duration>0"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedRadioOptionItem.min_duration"
                      label="Minimal duration"
                      clearable
                      :disabled="editedRadioOptionItem.duration>0"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedRadioOptionItem.discount_after"
                      label="Discount after"
                      clearable
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedRadioOptionItem.discount_percentage"
                      label="Discount %"
                      clearable
                      :disabled="!editedRadioOptionItem.discount_after"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    sm="6"
                    md="4"
                  >
                    <v-text-field
                      v-model.trim="editedRadioOptionItem.websiteText"
                      label="Website text"
                      clearable
                    />
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="$emit('close-radio-option')"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="ppc_darkgreen darken-1"
                  text
                  @click="saveRadioOption(editedRadioOptionItem)"
                >
                  Done
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="$emit('open-radio-group', item)"
        >
          $vuetify.icons.icon_mdi_pencil
        </v-icon>

        <v-icon
          small
          @click="$emit('delete-radio-group', item)"
        >
          $vuetify.icons.icon_mdi_delete
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import inputRules from '@/mixins/inputRules'

export default {
  name: 'ServiceRadioGroups',

  watch: {
    dialogRadioGroup(value) {
      if (value) {
        this.$nextTick(() => {
          this.$refs.radioGroupForm?.resetValidation()
        })
      }
    }
  },

  mixins: [inputRules],

  data() {
    return {
      selectedDefaultOption: [],
    }
  },

  props: {

    headersRadioGroups: {
      type: Array,
      default: () => [],
    },

    headersRadioOptions: {
      type: Array,
      default: () => [],
    },

    updatedAvailableRadioGroups: {
      type: Array,
      default: () => [],
    },

    dialogRadioGroup: {
      type: Boolean,
      default: false,
    },

    dialogDeleteRadioGroup: {
      type: Boolean,
      default: false,
    },

    formTitleRadioGroups: {
      type: String,
      default: '',
    },

    editedRadioGroup: {
      type: Object,
      required: true
    },

    dialogRadioOption: {
      type: Boolean,
      default: false,
    },

    editedRadioOptionItem: {
      type: Object,
      required: true,
    },

    formTitleRadioOptions: {
      type: String,
      default: '',
    },

  },

  methods: {

    saveRadioGroup () {
      if (this.$refs.radioGroupForm.validate()) {
        this.$emit('save-radio-group')
      }
    },

    saveRadioOption () {
      if (this.$refs.formRadioOptions.validate()) {
        this.$emit('add-edit-radio-option')
      }
    },

    changeDefault(item) {
      this.editedRadioGroup.radio_group_value = item.item.label
    },

  },
}
</script>